import ScalarHeaderButton_vue_vue_type_script_setup_true_lang_default from "./ScalarHeaderButton.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarHeader/ScalarHeaderButton.vue
var ScalarHeaderButton_default = ScalarHeaderButton_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarHeaderButton_default as default };

//# sourceMappingURL=ScalarHeaderButton.vue.js.map